import Main from '@/views/administracion/planeacion/Main.vue';
import Default from '@/views/administracion/planeacion/Default.vue';
import MainObra from '@/views/administracion/planeacion/obra/Main.vue';
import DefaultObra from '@/views/administracion/planeacion/obra/Default.vue';
import MainDocumenosRelacionados from '@/views/administracion/planeacion/obra/documentosrelacionados/Main.vue';

const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const planeacion = [
  {
    path: 'planeacion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'planeacion',
        path: '/',
        meta: {
          title: 'Planeacion',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
      {
        path: ':idObra',
        meta: {
          title: 'Obra',
          auth,
          scopes,
        },
        component: MainObra,
        children: [
          {
            name: 'obra',
            path: '/',
            meta: {
              title: 'Obra',
              auth,
              scopes,
            },
            component: DefaultObra,
          },
          {
            name: 'obraDocumentosRelacionados',
            path: 'documentos-relacionados',
            meta: {
              title: 'Documentos Relacionados',
              auth,
              scopes,
            },
            component: MainDocumenosRelacionados,
          },
        ],
      },
    ],
  },
];

export default planeacion;
